/**
 * AI Provider (Stub)
 * 
 * This is a placeholder for future AI provider abstraction.
 * Currently not used in the Phase 3A/4 workflow.
 */

export interface AIProvider {
  name: string;
  models: string[];
}

export const AI_PROVIDERS: AIProvider[] = [
  {
    name: 'anthropic',
    models: ['claude-sonnet-4-5', 'claude-opus-4-1-20250805', 'claude-3-7-sonnet-20250219'],
  },
  {
    name: 'openai',
    models: ['gpt-4', 'gpt-3.5-turbo'],
  },
];

export function getProvider(name: string): AIProvider | undefined {
  return AI_PROVIDERS.find(p => p.name === name);
}

export async function sendChatMessage(
  _messages: any[],
  _userMessage: any,
  _settings: any
): Promise<{ message: string }> {
  console.warn('sendChatMessage is not implemented yet');
  return { message: 'AI chat is not implemented yet' };
}
